/**
 * 학원 대표 전화번호가 display 가능한지 판단해 trim된 값 또는 null을 반환한다.
 * Modal은 null이면 i18n fallbackContact 메시지를 렌더한다.
 *
 * @see docs/superpowers/specs/2026-05-09-lc-learner-account-recovery-design.md §3.2 / §6
 */
export function getDisplayablePhone(
  raw: string | null | undefined,
): string | null {
  if (raw == null) return null
  const trimmed = raw.trim()
  if (trimmed.length === 0) return null
  return trimmed
}

/**
 * 학원명을 모달에 렌더할지 판단한다. null/empty/whitespace는 렌더 생략 (spec §6).
 */
export function shouldShowTenantName(
  name: string | null | undefined,
): boolean {
  if (name == null) return false
  return name.trim().length > 0
}
